export const drawingConstants = {
    SET_DRAWING: 'DRAWING_SET_DRAWING',
};
